import { defineAsyncComponent } from 'vue';
import { mountVueComponent } from '@/components/mountVueComponents';

const subscriptionFormEl = document.querySelector('.js-newsletter-subscription-form');

if (subscriptionFormEl) {
  const subsciptionForm = defineAsyncComponent(() => import('@/components/newsletter/NewsletterSubscribe.vue'));
  mountVueComponent(subscriptionFormEl, subsciptionForm, 'NewsletterSubscription');
}
